import axios, { type AxiosError } from 'axios';
import { isConnectionError } from './errors';

const baseURL = import.meta.env.VITE_API_BASE_URL || '/api';

let getAuthToken: (() => Promise<string | null>) | null = null;

export function setAuthTokenGetter(fn: () => Promise<string | null>): void {
  getAuthToken = fn;
}

export const axiosClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 12000,
});

axiosClient.interceptors.request.use(
  async (config) => {
    if (!config.headers['X-Request-Id']) {
      config.headers['X-Request-Id'] = crypto.randomUUID();
    }
    if (getAuthToken) {
      const token = await getAuthToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (!error.response) {
      if (isConnectionError(error)) {
        return Promise.reject(new Error('Connection refused: Backend server is not available'));
      }
      return Promise.reject(error);
    }
    const message =
      (error.response?.data as { error?: { message?: string } } | undefined)?.error?.message ??
      error.message;
    return Promise.reject(new Error(message));
  }
);
